import React from 'react';
import { toast } from 'react-toastify';

const ConfirmMail = ({
  open,
  setOpen,
  onConfirm,
  getTo,
  getSubject,
  getText,
  getSender
}) => {
  const notify = () => toast("Vous avez envoyé un mail");

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
    notify();
  };

  const handleCancel = () => {
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="confirm-mail">
      <div className="confirm-mail__overlay" onClick={handleCancel}></div>

      <div className="confirm-mail__modal">
        <div className="confirm-mail__header">
          <h2 className="confirm-mail__title">Confirmation d'envoi</h2>
          <button
            className="confirm-mail__close"
            onClick={handleCancel}
            aria-label="Fermer"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="confirm-mail__content">
          <div className="confirm-mail__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </div>

          <p className="confirm-mail__message">
            Confirmez-vous l'envoi de ce mail ?
          </p>

          <div className="confirm-mail__details">
            <div className="confirm-mail__detail">
              <strong>De :</strong> {getSender || 'Non spécifié'}
            </div>
            <div className="confirm-mail__detail">
              <strong>À :</strong> {getTo || 'Non spécifié'}
            </div>
            <div className="confirm-mail__detail">
              <strong>Objet :</strong> {getSubject || 'Non spécifié'}
            </div>
          </div>
        </div>

        <div className="confirm-mail__actions">
          <button
            className="confirm-mail__btn confirm-mail__btn--cancel"
            onClick={handleCancel}
          >
            Annuler
          </button>
          <button
            className="confirm-mail__btn confirm-mail__btn--confirm"
            onClick={handleConfirm}
          >
            Envoyer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmMail;